<div class="sidePanelEmptyFolderMessage">
  <div class="sidePanelEmptyFolderMessage__inner">
    {{ 'favourites_empty' | ppTranslate }}
  </div>
</div>
